/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260/A280 of about 1.8 indicates pure DNA.`)
};

const es_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un A260/A280 de aproximadamente 1.8 indica ADN puro.`)
};

const de_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein A260/A280 von etwa 1,8 deutet auf reine DNA hin.`)
};

const nl_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een A260/A280 van ongeveer 1,8 duidt op zuiver DNA.`)
};

const fr_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un A260/A280 d'environ 1,8 indique un ADN pur.`)
};

const it_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260/A280 di circa 1,8 indica DNA puro.`)
};

const pt_br2_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260/A280 de aproximadamente 1,8 indica DNA puro.`)
};

const pt_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um A260/A280 de cerca de 1,8 indica ADN puro.`)
};

const ja_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260/A280が約1.8であれば、純粋なDNAを示します。`)
};

const zh_od_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260/A280 约为 1.8 表示 DNA 纯度较高。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_ex3", locale)
	if (locale === "en") return en_od_ex3(inputs)
	if (locale === "es") return es_od_ex3(inputs)
	if (locale === "de") return de_od_ex3(inputs)
	if (locale === "nl") return nl_od_ex3(inputs)
	if (locale === "fr") return fr_od_ex3(inputs)
	if (locale === "it") return it_od_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_od_ex3(inputs)
	if (locale === "pt") return pt_od_ex3(inputs)
	if (locale === "ja") return ja_od_ex3(inputs)
	return zh_od_ex3(inputs)
};